import { Language } from '../../types/language'

export type JourneyStep = {
  title: string
  description: string
  sessions: string
}

export type JourneyCopy = {
  intro: string
  title: string
  startLabel: string
  endLabel: string
  outro: string
  cta: string
  steps: JourneyStep[]
}

export const journeyCopy: Record<Language, JourneyCopy> = {
  nl: {
    title: 'Jouw traject in vier stappen',
    intro:
      'Ik ontwikkelde een coachingmodel in vier stappen, gebaseerd op de principes van ICF. Het helpt je afstand te nemen van de dagelijkse druk, de regie over je keuzes terug te pakken en je eigen richting te bepalen.',
    startLabel: 'Vastgelopen',
    endLabel: 'Helderheid en richting',
    outro:
      'Zes sessies van een uur, ongeveer elke twee weken. Online of wandelend in de omgeving van Utrecht.',
    cta: 'Plan een kennismaking',
    steps: [
      {
        title: 'Connection Talk',
        description: 'We maken kennis, telefonisch of wandelend',
        sessions: 'Gratis, 30 minuten',
      },
      {
        title: 'Life Scan',
        description: 'Zie waar je nu staat',
        sessions: 'Sessie 1 en 2',
      },
      {
        title: 'Future Focus',
        description: 'Bepaal waar je heen wilt',
        sessions: 'Sessie 3 en 4',
      },
      {
        title: 'Clarity Roadmap',
        description: 'Zet je volgende stap',
        sessions: 'Sessie 5 en 6',
      },
    ],
  },
  en: {
    title: 'Your journey in four steps',
    intro:
      'I created a four-step coaching model, based on ICF principles. It helps you step back from daily pressure, regain ownership of your choices, and define your own direction.',
    startLabel: 'Feeling stuck',
    endLabel: 'Clarity and direction',
    outro:
      'Six one-hour sessions, roughly every two weeks. Online or walking in the Utrecht area.',
    cta: 'Book an intro call',
    steps: [
      {
        title: 'Connection Talk',
        description: 'We get to know each other, by phone or on a walk',
        sessions: 'Free, 30 minutes',
      },
      {
        title: 'Life Scan',
        description: 'See where you are now',
        sessions: 'Session 1 and 2',
      },
      {
        title: 'Future Focus',
        description: 'Define where you want to go',
        sessions: 'Session 3 and 4',
      },
      {
        title: 'Clarity Roadmap',
        description: 'Take your next step',
        sessions: 'Session 5 and 6',
      },
    ],
  },
}
